var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRemoteControlIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 4V6.67L12.5 7.67L11.5 6.67V4H13.5ZM20.5 11V13H17.83L16.83 12L17.83 11H20.5ZM7.17 11L8.17 12L7.17 13H4.5V11H7.17ZM12.5 16.33L13.5 17.33V20H11.5V17.33L12.5 16.33ZM15.5 2H9.5V7.5L12.5 10.5L15.5 7.5V2ZM22.5 9H17L14 12L17 15H22.5V9ZM8 9H2.5V15H8L11 12L8 9ZM12.5 13.5L9.5 16.5V22H15.5V16.5L12.5 13.5Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRemoteControlIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Remote_Control_icon.bb058e90f33fba386c5def1d41bd6841.svg";